import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PATH_DASHBOARD } from "../../routes/paths";
import axiosInstance from "../../utils/axios";

const initialState = {
  fetchLoading: false,
  isLoading: false,
  riders: [],
};

export const createRider = createAsyncThunk(
  "createRider/rider",
  async ({ data, enqueueSnackbar, navigate }, thunkApi) => {
    try {
      const response = await axiosInstance.post("riders", data);
      enqueueSnackbar("Rider is added successfully");
      navigate(PATH_DASHBOARD.riders.list);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const fetchRiders = createAsyncThunk(
  "fetchRiders/rider",
  async ({ enqueueSnackbar }, thunkApi) => {
    try {
      const response = await axiosInstance.get("riders");
      return {
        data: response.data.data.data,
        meta: {
          total: response.data.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const updateRider = createAsyncThunk(
  "updateRider/rider",
  async ({ id, data, enqueueSnackbar, setOpenEdit, handleClose }, thunkApi) => {
    try {
      const response = await axiosInstance.put(`riders/${id}`, data);
      handleClose();
      return {
        data: response.data.data,
        enqueueSnackbar,
        setOpenEdit,
        id,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const deleteRider = createAsyncThunk(
  "deleteRider/rider",
  async ({ id, enqueueSnackbar }, thunkApi) => {
    try {
      await axiosInstance.delete(`riders/${id}`);
      return { id, enqueueSnackbar };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const assignRider = createAsyncThunk(
  "assignRider/rider",
  async ({ orderCode, data, enqueueSnackbar }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(
        `orders/${orderCode}/assign-rider`,
        data
      );
      return response.data.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const riderSlice = createSlice({
  name: "riders",
  initialState,
  extraReducers: (builder) => {
    // TODO: create product
    builder.addCase(createRider.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createRider.fulfilled, (state) => {
      state.isLoading = false;
    });

    builder.addCase(createRider.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: fetch product
    builder.addCase(fetchRiders.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchRiders.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.riders = action.payload;
    });

    builder.addCase(fetchRiders.rejected, (state, action) => {
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: update product
    builder.addCase(updateRider.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateRider.fulfilled, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar("Rider is updated successfully");
      state.riders.data = state.riders.data.map((rider) =>
        rider.id === action.payload.id ? action.payload.data : rider
      );
      // action.payload.setOpenEdit(false);
    });

    builder.addCase(updateRider.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: delete product
    builder.addCase(deleteRider.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteRider.fulfilled, (state, action) => {
      state.isLoading = false;
      state.riders.data = state.riders.data.filter(
        (product) => product.id !== action.payload.id
      );
      action.payload.enqueueSnackbar("Rider is deleted successfully");
    });

    builder.addCase(deleteRider.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================
  },
});

export default riderSlice.reducer;
